import React from "react";

const EmailSupport = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Email</div>


        </div>
    );
};

export default EmailSupport